import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  EditStudentUserService,
  addStudentUserService,
  deleteStudentUserService,
  getStudentUserService,
  getStudentUserbyIdService,
} from "../../../../../utils/services/userManagement/student/studentServices";

// Get Student
export const getStudentUser = createAsyncThunk(
  "/student/get",
  async (payload, thunkAPI) => {
    const state = thunkAPI.getState();
    const {advancedSearch} = state?.student?.students;
    
    const obj = {
      ...payload,
      ...advancedSearch,
    } 
    
    console.log(obj, "dddddddddddddddddddddddddddddddddd")

    const response = await getStudentUserService(obj);
    if (response?.error) {
      return thunkAPI.rejectWithValue(response?.error);
    }
    return response;
  }
);

// Get Student by id
export const getStudentUserByID = createAsyncThunk(
  "/student/add",
  async (payload, thunkAPI) => {
    const response = await getStudentUserbyIdService();
    if (response?.error) {
      return thunkAPI.rejectWithValue(response?.error);
    }
    return response;
  }
);

// Add Student
export const addStudentUser = createAsyncThunk(
  "/student/add",
  async (payload, thunkAPI) => {
    console.log("student // payload we got in action creator", payload);
    const response = await addStudentUserService(payload);
    if (response?.statusCode === 200 || response?.statusCode === 201) {
      thunkAPI.dispatch(getStudentUser());
    }
    return response;
  }
);

//edit student
export const EditStudentUser = createAsyncThunk(
  "/student/add",
  async (payload, thunkAPI) => {
    console.log("student // payload we got in action creator for edit", payload);
    const response = await EditStudentUserService(payload);
    if (response?.statusCode === 200 || response?.statusCode === 201) {
      thunkAPI.dispatch(getStudentUser());
    }
    return response;
  }
);


// Delete Student
export const deleteStudentUser = createAsyncThunk(
  "/student/delete",
  async (payload, thunkAPI) => {
    console.log("Student to delete is  : ", payload?.studentToDelete)
    const response = await deleteStudentUserService(payload);
    if (response?.statusCode === 200 || response?.statusCode === 201) {
      thunkAPI.dispatch(getStudentUser());
    }
    return response;
  }
);

// export const addStudentUser = createAsyncThunk(
//   "/student/add",
//   async (payload) => {
//     const response = await addStudentUserService(payload);
//     return response;
//   }
// );
